import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import brandLogo from '@/Fi16100/Images/16100_fi.webp';
import './BrandLogo.css';
import {I18nContext} from 'react-i18next';

function BrandLogo(props) {
	const t = useContext(I18nContext).i18n.t;
	const className = (props.className ?? '') + ' brand-logo pe-none user-select-none py-1';

	return (
		<div className={className}>
			<img src={brandLogo} alt={t('app.brandLogoAlt')} />
		</div>
	);
}

BrandLogo.propTypes = {
	className: PropTypes.string
}

export default BrandLogo;
